export default {
  mini: false,
  color: 'primary'
  // image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg'
}
